import { isMobile } from "@modules/util/device.ts"
import { dispatchGlobalEvent } from "@modules/util/events"
import { advertCardsContainerElement } from "../global/dom.ts"
import { getQueryParameter, removeQueryParameter, setQueryParameter } from "../util/query-parameter"
import { fetchAffiliateAdverts, setAffiliateAdverts } from "./affiliates"
import {} from "./affiliates"
import { afterFilterApiFetched } from "./after-filter-api-fetched"
import { fetchApiWithAllFilters } from "./api"
import { getAdvertsCardType } from "./get-advert-card-view-type"

const viewTypeGalleryElement = () => document.querySelector<HTMLElement>("#change-view-type-gallery")
const viewTypeGalleryIcon = () => document.querySelector<SVGElement>("#change-view-type-gallery svg")
const viewTypeListElement = () => document.querySelector<HTMLElement>("#change-view-type-list")
const viewTypeListIcon = () => document.querySelector<SVGElement>("#change-view-type-list svg")
const resultsTopBarContainer = () => document.querySelector("section.options-container.top")

function updateCardViewTypeInDom() {
    // idk old code seems to set it cna be removed at some point
    viewTypeGalleryElement()?.classList.remove("disabled")
    viewTypeListElement()?.classList.remove("disabled")

    if (getAdvertsCardType() === "list") {
        advertCardsContainerElement()?.classList.add("azm-type-list")
        advertCardsContainerElement()?.classList.remove("azm-type-gallery")
        const listIcon = viewTypeListIcon()
        if (listIcon) listIcon.style.fill = "#555"
        const galleryIcon = viewTypeGalleryIcon()
        if (galleryIcon) galleryIcon.style.fill = ""
    } else {
        advertCardsContainerElement()?.classList.remove("azm-type-list")
        advertCardsContainerElement()?.classList.add("azm-type-gallery")
        const galleryIcon = viewTypeGalleryIcon()
        if (galleryIcon) galleryIcon.style.fill = "#555"
        const listIcon = viewTypeListIcon()
        if (listIcon) listIcon.style.fill = ""
    }
}

updateCardViewTypeInDom()

viewTypeGalleryElement()?.addEventListener("click", async (clickEvent) => {
    clickEvent.preventDefault()

    if (getQueryParameter("ansicht") === "gallery") {
        return
    }

    dispatchGlobalEvent("azm.view-type.change", "gallery")

    if (isMobile()) {
        setQueryParameter("ansicht", "gallery")
    } else {
        removeQueryParameter("ansicht")
    }
    setAffiliateAdverts(await fetchAffiliateAdverts())

    await afterFilterApiFetched(await fetchApiWithAllFilters())

    updateCardViewTypeInDom()
})
viewTypeListElement()?.addEventListener("click", async (clickEvent) => {
    clickEvent.preventDefault()

    if (getQueryParameter("ansicht") === "list") {
        return
    }

    dispatchGlobalEvent("azm.view-type.change", "list")

    if (isMobile()) {
        removeQueryParameter("ansicht")
    } else {
        setQueryParameter("ansicht", "list")
    }
    setAffiliateAdverts(await fetchAffiliateAdverts())

    await afterFilterApiFetched(await fetchApiWithAllFilters())

    updateCardViewTypeInDom()
})

export function hideResultsTopBar() {
    resultsTopBarContainer()?.classList.add("hidden")
}

export function showResultsTopBar() {
    resultsTopBarContainer()?.classList.remove("hidden")
}

SearchConfig.advertCount === 0 ? hideResultsTopBar() : showResultsTopBar()
